<template>
  <div class="legal-page">
    <div class="legal-container">
      <h1 class="legal-title">{{ $t("legal.privacyPolicy.title") }}</h1>
      <p class="last-updated">{{ $t("legal.privacyPolicy.lastUpdated") }}</p>
      <section
        v-for="(section, index) in sections"
        :key="index"
        class="legal-section"
      >
        <h2 class="section-title">{{ section.title }}</h2>
        <div
          v-for="(block, bIndex) in section.blocks"
          :key="bIndex"
          class="legal-block"
        >
          <h3 v-if="block.subtitle" class="subsection-title">
            {{ block.subtitle }}
          </h3>
          <p
            v-for="(para, pIndex) in block.paragraphs"
            :key="'p-' + pIndex"
            class="paragraph"
            v-html="para"
          ></p>
          <ul v-if="block.list && block.list.length" class="legal-list">
            <li v-for="(item, lIndex) in block.list" :key="'l-' + lIndex" v-html="item"></li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  computed: {
    sections() {
      const sections = this.$t("legal.privacyPolicy.sections", {
        returnObjects: true,
      });
      return Array.isArray(sections) ? sections : [];
    },
  },
};
</script>

<style scoped>
.legal-page {
  background-color: #f8f9fa;
  padding: 60px 0 80px;
  min-height: calc(100vh - 200px);
}

.legal-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 50px 60px;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.legal-title {
  font-size: 2.5rem;
  color: #1a1a2e;
  margin: 0 0 12px;
  padding-bottom: 20px;
  border-bottom: 3px solid #007bff;
  font-weight: 700;
}

.last-updated {
  font-size: 0.9rem;
  color: #6c757d;
  margin: 0 0 28px;
}

.legal-section {
  margin-bottom: 28px;
}

.section-title {
  font-size: 1.4rem;
  color: #1a1a2e;
  margin: 0 0 16px;
  font-weight: 600;
}

.subsection-title {
  font-size: 1.15rem;
  color: #34495e;
  margin: 24px 0 12px;
  font-weight: 600;
}

.paragraph {
  font-size: 1rem;
  line-height: 1.8;
  color: #4a5568;
  margin: 0 0 16px;
  text-align: justify;
}

.legal-list {
  margin: 12px 0 20px;
  padding-left: 28px;
}

.legal-list li {
  font-size: 1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 8px;
}

::v-deep .legal-highlight {
  color: #007bff;
  font-weight: 600;
  text-decoration: none;
  background-color: rgba(0, 123, 255, 0.08);
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.3s ease;
  word-break: break-all;
}

::v-deep .legal-highlight:hover {
  color: #0056b3;
  background-color: rgba(0, 123, 255, 0.15);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-page {
    padding: 40px 0;
  }

  .legal-container {
    margin: 0 20px;
    padding: 30px 24px;
    border-radius: 12px;
  }

  .legal-title {
    font-size: 1.8rem;
  }
}
</style>
